import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
import CommentPost from 'flarum/forum/components/CommentPost';
import DiscussionListItem from 'flarum/forum/components/DiscussionListItem';
import ComposerPostPreview from 'flarum/forum/components/ComposerPostPreview';
const swiperOptions = {
  centeredSlides: true,
  centeredSlidesBounds: true,
  spaceBetween: 30,
  zoom: true,
  pagination: {
    el: '.swiper-pagination',
    type: 'fraction'
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  }
};
const obtainSwiper = async () => {
  try {
    return await import(/* webpackChunkName: 'forum/external/Swiper', webpackMode: 'lazy-once' */ './external/Swiper');
  } catch (err) {
    console.error('Failed to load Swiper.', err);
  }
  return null;
};
const createGalleries = async ($container, galleries) => {
  const $elements = $container.find('img:not(.emoji) + br + img:last-of-type, a:has(img:not(.emoji)) + br + a:has(img:not(.emoji)):last-of-type');
  if (!$elements.length) return;
  const useZoom = app.forum.attribute('useSwiperZoom');
  const {
    Swiper,
    Navigation,
    Pagination,
    Zoom
  } = (await obtainSwiper()) || {};
  if (!Swiper) return;
  const opts = {
    modules: [Navigation, Pagination, useZoom && Zoom].filter(Boolean),
    ...swiperOptions
  };
  $elements.each(function () {
    if (this.hasAttribute('data-flarum-post-gallery')) return;
    this.setAttribute('data-flarum-post-gallery', '');
    const images = $(this).siblings('img:not(.emoji), a:has(img:not(.emoji))').add(this);
    $(images).siblings('br').remove();
    images.wrapAll($('<div/>').addClass('swiper-wrapper')).wrap($('<div/>').addClass('swiper-slide'));
    if (useZoom) {
      images.wrap($('<div/>').addClass('swiper-zoom-container'));
    }
    const swiperWrapper = $(this).closest('.swiper-wrapper')[0];
    $(swiperWrapper).wrap($('<div/>').addClass('swiper'));
    const swiperEl = swiperWrapper.parentElement;
    $(swiperEl).append($('<div/>').addClass('swiper-pagination')).append($('<div/>').addClass('swiper-button-prev')).append($('<div/>').addClass('swiper-button-next'));
    galleries.push(new Swiper(swiperEl, opts));
  });
};
const destroyGalleries = galleries => {
  galleries?.forEach(gallery => gallery.destroy());
  return [];
};
const registerDestroy = prototype => {
  extend(prototype, 'onremove', function () {
    this.galleries = destroyGalleries(this.galleries);
  });
};
const register = (prototype, selector) => {
  extend(prototype, ['oncreate', 'onupdate'], function () {
    const $container = this.$(selector);
    if ($container.length) {
      this.galleries = destroyGalleries(this.imageGallery);
      createGalleries($container, this.galleries);
    }
  });
  registerDestroy(prototype);
};
app.initializers.add('datitisev/flarum-post-galleries', () => {
  register(CommentPost.prototype, '.Post-body');
  register(DiscussionListItem.prototype, '.DiscussionListItem-info');
  extend(ComposerPostPreview.prototype, 'oncreate', function () {
    var _this = this;
    override(this.attrs, 'surround', function (orig) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      orig(...args);
      _this.galleries = destroyGalleries(_this.galleries);
      createGalleries(_this.$(), _this.galleries);
    });
  });
  extend(ComposerPostPreview.prototype, 'onremove', function () {
    this.galleries = destroyGalleries(this.galleries);
  });
  extend('flarum/forum/components/ReplyPlaceholder', 'anchorPreview', function () {
    this.galleries = destroyGalleries(this.galleries);
    createGalleries(this.$('.Post-body'), this.galleries);
  });
  registerDestroy('flarum/forum/components/ComposerPostPreview');
  registerDestroy('flarum/forum/components/ReplyPlaceholder');
});flarum.reg.addChunkModule('835', '947', 'datitisev-post-galleries', 'forum/external/Swiper');